import { useState } from "react";
import { Navigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

const BG = "https://images.pexels.com/photos/32358762/pexels-photo-32358762.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=940";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:block relative bg-[#38171E]">
        <img src={BG} alt="Florence" className="absolute inset-0 w-full h-full object-cover opacity-55 mix-blend-luminosity" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#38171E] via-[#38171E]/40 to-transparent" />
        <div className="absolute bottom-16 left-14 right-14 text-[#F3E5AB]">
          <div className="text-[10px] tracking-[0.34em] text-[#D4AF37] mb-4">EST. SOFTSPINEPRESS.COM</div>
          <p className="font-display text-4xl italic leading-tight">“Books, guides and quiet companions — set in type, bound in care.”</p>
        </div>
      </div>
      <div className="flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm rise" data-testid="login-form">
          <div className="eyebrow mb-3">Publisher sign-in</div>
          <img src="/ssp-logo.png" alt="Soft Spine Press" className="w-56 mb-6" data-testid="login-logo" />
          <h1 className="font-display text-5xl mb-10">SSP Tools</h1>
          <div className="space-y-5">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-2 bg-white" data-testid="login-email-input" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-2 bg-white" data-testid="login-password-input" />
            </div>
            {error && <p className="text-sm text-[#9B2C2C]" data-testid="login-error">{error}</p>}
            <Button type="submit" disabled={busy} className="w-full rounded-none h-11 tracking-wide" data-testid="login-submit-btn">
              {busy ? "Signing in…" : "Enter the studio"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
